import React from "react";
import styles from "./InfoStrings.module.css";

const infStrMap: Map<string, React.ReactNode> = new Map<string, React.ReactNode>([
    ["validation_source", (<div className={styles.iStrRootWithLineLeft}>
        <div className={styles.iStrTitle}>Attached Data</div>
        <div className={styles.iStrContent}>
            <div className={styles.iStrParagraph}>Attach data to the process & define how it should be used.</div>
        </div>
    </div>)],
    ["required", (<div className={styles.iStrRootWithLineLeft}>
            <div className={styles.toolRequiredInvDiv}>
                <div className={styles.iStrTitle}>Make Explicitly Required</div>
                <div className={styles.iStrContent}>
                    <div className={styles.iStrParagraph}>If checked, increasingly more advanced methods for extraction will be applied until a value is determined.</div>
                    <div className={styles.iStrImportant}>Don't check for fields that might not exist in all of your invoices.</div>
                </div>

            </div>
        </div>
        )
    ],
    ["is_key", (<div className={styles.iStrRootWithLineLeft}>
            <div className={styles.toolRequiredInvDiv}>
                <div className={styles.iStrTitle}>Direct Filtering</div>
                <div className={styles.iStrContent}>
                    <div className={styles.iStrParagraph}>If checked, we'll take the value of the invoice field and use it to filter the attached data by straight matching. </div>
                    <div className={styles.iStrImportant}>All other fields have filtered data to reconcile against.</div>
                </div>
            </div>
        </div>
        )
    ],
    ["is_or_filtering", (<div className={styles.iStrRootWithLineLeft}>
            <div className={styles.toolRequiredInvDiv}>
                <div className={styles.iStrTitle}>OR Filtering</div>
                <div className={styles.iStrContent}>
                    <div className={styles.iStrParagraph}>If checked, we'll use the value of the invoice field to filter the attached data as an OR condition to other filters</div>
                </div>
            </div>
        </div>
        )
    ]
]);

export type src_ids = "inv_conf" | "misc" ;
export type str_ids = "validation_source" | "required" | "is_key" | "is_or_filtering";




interface RecoCellProps {
    src_id: src_ids;
    str_id: str_ids;
}

const InfoStrings = React.memo(({ src_id, str_id }: RecoCellProps) => (
    infStrMap.get(str_id) || null
));

export default InfoStrings;
